export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Get a Quote',
      description: 'Contact us via phone, email, or our online form. Provide details about your move and receive a free, no-obligation quote within minutes.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '2',
      title: 'Book Your Move',
      description: 'Choose your preferred date and time. We offer flexible scheduling including evenings and weekends to suit your needs.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '3',
      title: 'We Handle Everything',
      description: 'Our professional team arrives on time with all necessary equipment. We carefully pack, load, transport, and unload your belongings.',
      icon: 'ri-truck-line'
    },
    {
      number: '4',
      title: 'Enjoy Your New Space',
      description: 'Relax while we complete the move efficiently. We ensure everything is placed exactly where you want it in your new location.',
      icon: 'ri-home-smile-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">How It Works</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Simple, straightforward process to get you moving in no time
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="absolute top-8 left-1/2 w-full h-0.5 bg-blue-200 -z-10 hidden lg:block" style={{ display: index === steps.length - 1 ? 'none' : 'block' }}></div>
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-gray-300 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
